import React from 'react';
import { Spin } from 'antd';
import LoaderIcon from './LoaderIcon';
import { loadingStates } from '../../constants/common';
import styles from './MainLoader.module.scss';

const MainLoader = ({ loadingState, loading, ...props }) => {
  const isLongLoading = loadingState === loadingStates.longLoading;

  return (
    <Spin
      indicator={<LoaderIcon hasProgress={isLongLoading} />}
      tip={
        isLongLoading
          ? 'Много данных. Загрузка займет некоторое время'
          : undefined
      }
      wrapperClassName={styles.root}
      spinning={loading || false}
      {...props}
    />
  );
};

export default MainLoader;
